import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["leftPoints", "rightPoints", "result", "winner", "criteriaInput", "criteriaDisplay"]

  connect() {
    this.criteria = 40; // Default bid criteria
  }

  // Set bid criteria based on user input and recalculate the winner
  setBidCriteria() {
    this.criteria = parseFloat(this.criteriaInputTarget.value) || 40;
    this.criteriaDisplayTarget.textContent = `${this.criteria}%`;
    this.updateBidCriteria();  // Recalculate the winner when the criteria is updated
  }

  updateBidCriteria() {
    const leftPoints = parseFloat(this.leftPointsTarget.value) || 0;
    const rightPoints = parseFloat(this.rightPointsTarget.value) || 0;

    // Handle the case where one or both points are 0
    if (leftPoints === 0 && rightPoints === 0) {
      this.winnerTarget.textContent = "No winner (both sides have 0 points)";
      return;
    } else if (leftPoints === 0) {
      this.winnerTarget.textContent = "Person 2 has the winning bid (left is 0)";
      return;
    } else if (rightPoints === 0) {
      this.winnerTarget.textContent = "Person 1 has the winning bid (right is 0)";
      return;
    }

    // Calculate the percentage difference between the bids
    const percentageDifference = this.calculatePercentage(leftPoints, rightPoints);

    // If the percentage difference is within the bid criteria, it's a tie
    if (percentageDifference <= this.criteria) {
      this.winnerTarget.textContent = "It's a tie";
    } else {
      // Otherwise, determine who is winning based on the points
      if (leftPoints > rightPoints) {
        this.winnerTarget.textContent = "Person 1 has the winning bid";
      } else {
        this.winnerTarget.textContent = "Person 2 has the winning bid";
      }
    }
  }

  // Calculate percentage difference between the two bids
  calculatePercentage(leftPoints, rightPoints) {
    return Math.abs(100 - (rightPoints * 100.0) / leftPoints + 0.5);
  }
}
